import { defineSlotRecipe } from '@chakra-ui/react';

const itemDimensions = {
    w: {
        base: 8,
        md: '42px',
    },
    h: {
        base: 8,
        md: '42px',
    },
    minW: {
        base: 8,
        md: '42px',
    },
};

const itemTypography = {
    fontSize: {
        base: 'sm',
        md: 'md',
    },
    fontWeight: 'bold',
    color: 'gray.900',
};

const itemLayout = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const itemHighlightedState = {
    borderColor: 'secondary.600',
    bg: 'secondary.600',
    color: 'white',
};

export const paginationSlotRecipe = defineSlotRecipe({
    slots: [
        'root',
        'arrow',
        'button',
        'staticPage',
        'ellipsisRoot',
        'ellipsisPlaceholder',
        'ellipsisInput',
    ],
    base: {
        root: {
            justifyContent: {
                base: 'center',
                md: 'flex-end',
            },
            my: 6,
        },
        arrow: {
            minW: 'auto',
            h: '100%',
            p: 0,
            color: 'secondary.600',
            '&:disabled': {
                color: 'gray.300',
                opacity: 1,
            },
        },
        button: {
            ...itemLayout,
            ...itemDimensions,
            ...itemTypography,
            borderRadius: 'md',
            border: '1px solid',
            borderColor: 'gray.900',
            bg: 'white',
            cursor: 'pointer',
            transition: 'all 0.2s',
            '&:hover:not(:disabled)': {
                ...itemHighlightedState,
            },
            '&[aria-current="page"]': {
                ...itemHighlightedState,
            },
        },
        staticPage: {
            ...itemLayout,
            ...itemDimensions,
            ...itemTypography,
        },
        ellipsisRoot: {
            position: 'relative',
            ...itemDimensions,
        },
        ellipsisPlaceholder: {
            ...itemLayout,
            ...itemDimensions,
            ...itemTypography,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            cursor: 'pointer',
            borderRadius: 'md',
            bg: 'white',
        },
        ellipsisInput: {
            ...itemLayout,
            ...itemDimensions,
            ...itemTypography,
            textAlign: 'center',
            borderRadius: 'md',
            bg: 'white',
            outline: 'none',
            px: 1,
        },
    },
});
